module.exports = __webpack_public_path__ + "static/media/UserCircle.79293dc0.svg";